import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteGroups, getDepartments, getCategory, insertGroup, getGroup, getCategorys,
} from "../../services/dataService";
import { data } from "jquery";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";


export default function Group() {
  const UID = localStorage.getItem("userId");
  const [uFetch, setUfetch] = useState({
    UserId: UID,
  });
  const [addGroupModal, setAddGroupModal] = useState(false);
  const [editGroupModal, setEditGroupModal] = useState(false);
  const [groups, setGroups] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);


  const [categorys, setCategorys] = useState([]);
  const [deleteGroupId, setDeleteGroupId] = useState(null); // Correct state declaration
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility

  const [loading, setLoading] = useState(false);
  ;

  const [CategoryName, setCategoryName] = useState();
  const [groupData, setGroupData] = useState({ Id: "", Name: "", Narration: "",  CategoryId: "", UserId: UID, });

  const openAddGroupModal = () => {
    setGroupData({ Id: "", Name: "", Narration: "",  CategoryId: "", UserId: UID, });
    setAddGroupModal(!addGroupModal);
  };

  useEffect(() => {
    const Category = categorys.find((item) => {
      if (item.Id == data?.CategoryId) {
        console.log(categorys, "crProfit");
        console.log(item, "critem");
        return item?.Name;
      }
    });
    setCategoryName(Category)
  }, [categorys])
  console.log("CategoryName", CategoryName);


  const openEditGroupModal = (data) => {
    console.log("data", data);
    const CategoryName = categorys.find((item) => {
      if (item.Id == data?.CategoryId) {
        console.log(categorys, "crProfit");
        console.log(item, "critem");
        return item?.Name;
      }
    });
    console.log("CategoryName", CategoryName);
    setGroupData({
      ...data,
      CategoryId: data?.CategoryId,
      // DepartmentId: data.DepartmentId,
      CategoryName: CategoryName?.Name,
      // Department: DepartmentName?.Name,
      UserId: UID || "",
    });
    setEditGroupModal(!editGroupModal);
  };

  useEffect(() => {
    console.log("groupData", groupData);
  }, [groupData]);

  useEffect(() => {
    setLoading(true);
    fetchGroups();
  }, []);

  useEffect(() => {
    if (groups && groups.length > 0) {
      const updatedData = groups.map((item, index) => {

        const category = categorys.find(c => c.Id === item.CategoryId);

        return {
          Slno: index + 1,
          Id: item.Id || "",
          Name: item.Name || "",
          Narration: item.Narration || "",
          Code: item.Code || "",
          // CategoryId: item.CategoryId || "",
          UserId: item.UserId || "",
          CategoryName: category ? category.Name : "",
        };
      });

      setDataFilter(updatedData);
    }
    else {
      setDataFilter([])
    }
  }, [groups, categorys]);


  const fetchGroups = async () => {
    try {
      const data = await getGroup(UID);
      console.log(data.data.data, "Fetched data");
      setGroups(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching groups", error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGroupData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await insertGroup(groupData);
      if (response.data.data.StatusCode === 200) {
        toast.success(response.data.data.message);

        openAddGroupModal();
        fetchGroups();

      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";
      if (errorMessage.includes("Duplicate Name")) {
        toast.error("The code or Name is already in use. Please use a unique code");
      } else {
        toast.error("Error occurred while adding Group");
      }
      console.error("Error adding Group:", error);
    } finally {
      setLoading(false);

    }

  };



  // edit

  const handleEdit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setLoading(true); // Set loading state to true

    try {
      const response = await insertGroup(groupData);
      if (response.data.data.StatusCode === 200) {
        toast.success(response.data.data.message); // Show success toast
        openEditGroupModal();
        fetchGroups(); // Refresh the list of groups
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.message ||
        "An unexpected error occurred.";

      if (errorMessage.includes("Duplicate Name")) {
        toast.error("The code or Name is already in use. Please use a unique code"); // Show specific error toast
      } else {
        toast.error("Error occurred while editing Group"); // General error toast
      }
      console.error("Error editing Group", error);
    } finally {
      setLoading(false); // Reset loading state
    }

  };

  // Category fetch
  useEffect(() => {
    const fetchCategorys = async () => {
      try {
        const response = await getCategorys(UID);
        // const responses = await getDepartments(UID);

        // setDepartment(responses.data.data);
        // console.log(department,"dept");

        setCategorys(response.data.data);
        console.log(categorys, "pro");
      } catch (error) {
        console.error("Error fetching Categorys:", error);
      }
    };

    fetchCategorys();
  }, []);

  // remove


  const handledelete = async (GroupId) => {
    const removeData = { Id: GroupId, TableName: "GroupMaster" };
    try {
      const res = await deleteGroups(removeData, UID); // Add await here

      if (res && res.data) {

        if (res.data.message === "Deleted Successfully") {
          toast.success("Group deleted successfully");
          fetchGroups(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Group");
      }
    } catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Group.";
        toast.error('Group already using cannot delete');
      } else {
        console.error("Error removing Group:", error);
        toast.error("Error deleting Group. Please try again.");
      }

    }
  };

  //
  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    { name: "Group Name", selector: (row) => row.Name, sortable: true },
    { name: "Remarks", selector: (row) => row.Narration, sortable: true },
    { name: "Code", selector: (row) => row.Code, sortable: true },

    // {
    //   name: "Category",
    //   selector: (row) => {
    //     const category = categorys?.find((el) => el.Id === row.CategoryId);
    //     console.log("111departmentName", category, "row.CommonDataId", row.CategoryId, 'groups', groups);

    //     return category ? category.Name : "N/A"; // Handle case where category is not found
    //   },
    //   sortable: true,
    // },


    {
      name: "Action", selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button className="bg-sky rounded-[4px] px-10 py-[8px]" onClick={() => openEditGroupModal(row)}>
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button className="bg-danger rounded-[4px] px-10 py-[8px]" onClick={() => openModal(row.Id)}>
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    }
  ];


  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
    const filteredItems = dataFilter.filter((item) => {
      const category = categorys?.find((el) => el.Id === item.CategoryId)?.Name;
    
      const filterableText = filterText.toLowerCase();
    
      return (
        (typeof item.Name === 'string' && item.Name.toLowerCase().includes(filterableText)) ||
        (typeof item.Code === "number" && item.Code.toString().toLowerCase().includes(filterableText))||

        (typeof item.Narration === 'string' && item.Narration.toLowerCase().includes(filterableText)) ||
        (typeof category === 'string' && category.toLowerCase().includes(filterableText))
      );
    });
    
  const subHeaderComponentMemo = useMemo(() => {

  }, [filterText, resetPaginationToggle]);


  const openModal = (groupId) => {
    setDeleteGroupId(groupId); // Store the ProfitCenter ID
    setIsModalOpen(true); // Open the modal
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
    setDeleteGroupId(null); // Clear the stored ID
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    console.log("FGFG", deleteGroupId);

    if (deleteGroupId) {
      handledelete(deleteGroupId); // Call handleDelete with the stored ID
    }
    closeModal(); // Close the modal after confirming
  };
  const clearData = () => {
    setGroupData({
      Id: "",
      Name: "",
      Narration: "",
      Code: "",
      CategoryId: "",
      CategoryName: 'Select Category',
      UserId: UID,
    });
  };

  const clearDataForEdit = () => {
    setGroupData((ref) => ({
      ...ref, // Spread the previous state
      Name: "",
      Narration: "",
      Code: "",
      CategoryId: "",
      UserId: UID, // Assuming UID is a variable or state you have defined
      CategoryName: 'Select Category'
    }));
  };

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Group?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete} // Confirm the deletion
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Group" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Group/Code"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddGroupModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={groups} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>

      {/* 
=====================================Add =============================================================== */}

      {addGroupModal && (
        <>

          <form onSubmit={handleSubmit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Add Group
                  <span className="absolute top-0 right-0">
                    <button onClick={openAddGroupModal} className="btn flex items-center justify-center">
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Group Name <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        id="name"
                        required
                        name="Name"
                        placeholder="Name"
                        value={groupData.Name}
                        onChange={handleChange}
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks </label>
                      <input
                        type="text"
                        id="narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={groupData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Code <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        required
                        id="code"
                        name="Code"
                        placeholder="Code"
                        value={groupData.Code}
                        onChange={handleChange}
                      />
                    </div> */}
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Category <span style={{ color: 'red' }}>*</span></label>
                      <select
                        name="CategoryId"
                        required
                        value={groupData.CategoryId}
                        onChange={handleChange}
                      >
                        <option value="" disabled>Select Category</option>
                        {categorys.map((center) => (
                          <option key={center?.Id} value={center?.Id}>{center?.Name}</option>
                        ))}
                      </select>
                    </div> */}
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button type="button" onClick={clearData} className="btn btn-outline-secondary">
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </div>
            </div>
          </form>


          <div
            // onClick={openAddGroupModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* 
=====================================Edit=============================================================== */}

      {editGroupModal && (
        <>
          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit Group
                  <span className="absolute top-0 right-0">
                    <button
                      onClick={openEditGroupModal}
                      className="btn flex items-center justify-center"
                    >
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Group Name <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        id="Name"
                        name="Name"
                        placeholder="Name"
                        value={groupData.Name}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "Name", value: e.target.value.trim() } });
                        }}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks </label>
                      <input
                        type="text"
                        id="Narration"
                        name="Narration"
                        placeholder="Remarks"
                        value={groupData.Narration}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Code <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        id="Code"
                        name="Code"
                        placeholder="Code"
                        value={groupData.Code}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                    {/* <div className="form-group flex col-span-12 flex-col">
                      <label>Category <span style={{ color: 'red' }}>*</span></label>
                      <select
                        name="CategoryId"
                        value={groupData.CategoryId}
                        onChange={handleChange}
                        required
                      >
                        <option key="" value="">
                          Select Category
                        </option>
                        {categorys?.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openEditGroupModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
